const currencySymbols = {
    'USD': '$', // US Dollar
    'EUR': '€', // Euro
    'CRC': '₡', // Costa Rican Colón
    'GBP': '£', // British Pound Sterling
    'ILS': '₪', // Israeli New Sheqel
    'INR': '₹', // Indian Rupee
    'JPY': '¥', // Japanese Yen
    'KRW': '₩', // South Korean Won
    'NGN': '₦', // Nigerian Naira
    'PHP': '₱', // Philippine Peso
    'PLN': 'zł', // Polish Zloty
    'PYG': '₲', // Paraguayan Guarani
    'THB': '฿', // Thai Baht
    'UAH': '₴', // Ukrainian Hryvnia
    'AED': 'د.إ', // United Arab Emirates Dirham
    'AUD': 'A$', // Australian Dollar
    'CAD': 'C$', // Canadian Dollar
    'HKD': 'HK$', // Hong Kong Dollar
    'IDR': 'Rp', // Indonesian Rupiah
    'LKR': 'Rs', // Sri Lankan Rupee
    'MYR': 'RM', // Malaysian Ringgit
    'NZD': 'NZ$', // New Zealand Dollar
    'SGD': 'S$', // Singapore Dollar
    'ZAR': 'R', // South African Rand
}
export default currencySymbols